import { useState, createContext } from "react";
import log from "loglevel";

const ModalContext = createContext({
  modalState: {
    loginVisible: false,
  },
  modalActions: {
    openLogin: () => {},
    closeLogin: () => {},
  },
});

const ModalProvider = ({ children }) => {
  log.debug('CONTEXT_MODAL_PROVIDER');

  const [loginVisible, setLoginVisible] = useState(false);

  const openLogin = () => {
    setLoginVisible(true);
  };

  const closeLogin = () => {
    setLoginVisible(false);
  };

  const value = {
    modalState: {
      loginVisible,
    },
    modalActions: {
      openLogin,
      closeLogin,
    },
  };

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};

export { ModalProvider };

export default ModalContext;
